export type AccessFlagSubsection = {
    key: string;
    flags: string[];
};

export type AccessFlagGroup = {
    key: string;
    icon: string;
    flags: string[];
    subsections?: AccessFlagSubsection[];
};

export const ACCESS_FLAG_GROUPS: AccessFlagGroup[] = [
    {
        key: 'customers',
        icon: '\u{1F464}', // 👤
        flags: [
            'CAN_ACCESS_CUSTOMERS_SECTION',
            'CAN_ARCHIVE_CUSTOMERS',
            'CAN_EDIT_CUSTOMERS_CREDENTIALS',
            'CAN_FORCE_DEFAULT_CREDENTIALS_CHANGE',
            'CAN_EXPORT_CUSTOMERS_CSV',
        ],
    },
    {
        key: 'financial',
        icon: '\u{1F4B3}', // 💳
        flags: [
            'CAN_ACCESS_IO_PAY',
            'CAN_CREDIT_POST_PAYMENT_CUSTOMERS_EWALLET',
            'CAN_CREATE_ORDERS_WITH_NEGATIVE_AMOUNT',
            'CAN_CREATE_ORDERS_WITH_NEGATIVE_BALANCE',
            'CAN_MANAGE_BRAND_EWALLET_OVERDRAFT',
            'CAN_MANAGE_CUSTOMER_EWALLET_OVERDRAFT',
        ],
    },
    {
        key: 'orders',
        icon: '\u{1F6D2}', // 🛒
        flags: [
            'CAN_CREATE_ORDER_WITH_CUSTOM_PRICE',
            'CAN_CREATE_ORDER_WITH_CUSTOM_PRICE_FOR_ALL_PRODUCTS',
            'CAN_CANCEL_ORDER_WITH_CONTRA_ENTRY',
            'CAN_SYNC_SALES',
        ],
    },
    {
        key: 'catalog',
        icon: '\u{1F4E6}', // 📦
        flags: [],
        subsections: [
            {
                key: 'categories',
                flags: ['MENU_CATEGORY_CREATE_OR_DELETE', 'MENU_CATEGORY_EDIT'],
            },
            {
                key: 'menus',
                flags: ['MENU_CREATE_OR_DELETE', 'MENU_EDIT'],
            },
            {
                key: 'products',
                flags: [
                    'MENU_PRODUCT_CREATE_OR_DELETE',
                    'MENU_PRODUCT_EDIT',
                    'CAN_ONLY_EDIT_PRICE_AND_PRODUCT_NAME',
                    'MENU_PRODUCT_EDIT_PRICE_ONLY',
                    'MENU_PRODUCT_EDIT_PRICE_BLOCKED_ONLY',
                    'CAN_CREATE_SKU',
                ],
            },
            {
                key: 'steps',
                flags: ['MENU_STEP_CREATE_OR_DELETE', 'MENU_STEP_EDIT'],
            },
            {
                key: 'tags',
                flags: ['MENU_TAG_CREATE_OR_DELETE', 'MENU_TAG_EDIT'],
            },
        ],
    },
    {
        key: 'subsidies',
        icon: '\u{1F3AB}', // 🎫
        flags: ['CAN_ACCESS_GRANTS_AND_ENTRANCE_FEES_SECTION'],
    },
    {
        key: 'configuration',
        icon: '\u{2699}\u{FE0F}', // ⚙️
        flags: ['CAN_EDIT_AREAS', 'CAN_EDIT_TABLE_LAYOUT', 'CAN_EDIT_AUTO_BILLING_REFERENTIAL'],
    },
    {
        key: 'administration',
        icon: '\u{1F510}', // 🔐
        flags: ['CAN_CHANGE_OWN_PASSWORD', 'CAN_MANAGE_BO_USERS', 'CAN_ACCESS_BRAND_HISTORY'],
    },
];

// Helper to get all flags from a group (including subsections)
export const getAllFlagsFromGroup = (group: AccessFlagGroup): string[] => {
    const subsectionFlags = group.subsections?.flatMap((s) => s.flags) ?? [];
    return [...group.flags, ...subsectionFlags];
};

// Helper to get all flags from all groups
export const getAllGroupedFlags = (): string[] => {
    return ACCESS_FLAG_GROUPS.flatMap(getAllFlagsFromGroup);
};
